import React, { useState } from 'react';
import {
    Anchor,
    Box,
    Button,
    Form,
    FormField,
    Heading,
    Page,
    PageContent,
    TextInput,
} from 'grommet';
import { Key, MailOption } from 'grommet-icons';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import AppConstants from '../../helpers/AppConstants.js';

export function Login() {
    const [value, setValue] = useState({ email: '', password: '' });
    const [buttonBusy, setButtonBusy] = useState(false);
    const [formError, setFormError] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async () => {
        setButtonBusy(true);
        try {
            const loginResponse = await axios.post(
                `${process.env.REACT_APP_ENRICH_CMS_ENDPOINT}/api/auth/local`,
                {
                    identifier: value.email,
                    password: value.password,
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                },
            );

            localStorage.setItem(
                AppConstants.cacheKeys.authToken,
                loginResponse.data.jwt,
            );

            localStorage.setItem(
                AppConstants.cacheKeys.userId,
                loginResponse.data.user.id,
            );

            navigate('/');
        } catch (error) {
            console.log(error);
            setFormError(
                error?.message ?? 'There was an issue with authentication.',
            );
        }
        setButtonBusy(false);
    };

    return (
        <Page>
            <PageContent>
                <Box width="medium">
                    <Heading level="3">Login</Heading>
                    <Form
                        value={value}
                        onChange={(nextValue) => setValue(nextValue)}
                        onSubmit={() => handleSubmit(value)}>
                        <Box gap="small">
                            <FormField
                                name="email"
                                htmlFor="email-input-id"
                                label="Email">
                                <TextInput
                                    name="email"
                                    id="email-input-id"
                                    icon={<MailOption />}
                                />
                            </FormField>
                            <FormField
                                name="password"
                                htmlFor="password-input-id"
                                label="Password"
                                error={formError}>
                                <TextInput
                                    name="password"
                                    id="password-input-id"
                                    type="password"
                                    icon={<Key />}
                                />
                            </FormField>
                            <Button
                                type="submit"
                                primary
                                label="Submit"
                                busy={buttonBusy}
                            />
                            <Anchor
                                label="Forgot password?"
                                onClick={() => navigate('/forgot-password')}
                                alignSelf="center"
                            />
                        </Box>
                    </Form>
                </Box>
            </PageContent>
        </Page>
    );
}

export function clearUserData() {
    localStorage.removeItem(AppConstants.cacheKeys.authToken);
    localStorage.removeItem(AppConstants.cacheKeys.userId);
    localStorage.removeItem(AppConstants.cacheKeys.resumeReviewerId);
    localStorage.removeItem(AppConstants.cacheKeys.coachId);
    localStorage.removeItem(AppConstants.cacheKeys.welcomeCallCoachId);
}

export function hasToken() {
    if (localStorage.getItem(AppConstants.cacheKeys.authToken)) {
        return true;
    }

    return false;
}

export function hasUserId() {
    if (localStorage.getItem(AppConstants.cacheKeys.userId)) {
        return true;
    }

    return false;
}

export function hasResumeReviewerId() {
    if (localStorage.getItem(AppConstants.cacheKeys.resumeReviewerId)) {
        return true;
    }
    return false;
}
